import React from 'react';
import { RiArrowDownDoubleFill } from 'react-icons/ri';
import './Wavee.scss';

const Wavee = () => (
  <>
    <a
      className="app__wave"
      href="#contacts"
    >
      <RiArrowDownDoubleFill className="blinking-arrow" />
    </a>
  </>
);
//   return (
//     <>
//       <a
//         className="app__wave"
//         href="#contacts"
//       >
//         <RiArrowDownDoubleFill className="blinking-arrow" />
//       </a>
//     </>
//   );
// };

export default Wavee;
